module.exports = __webpack_public_path__ + "static/media/painting.204463d2.png";